export const SANS_SERIF_FONT_FAMILY = 'Lato, sans-serif'
export const SERIF_FONT_FAMILY = 'Playfair Display, serif'

export const fontFamily = 'Mulish, sans-serif'

export const textColorDark = '#373f41'
export const textColorLight = '#737b7d'

export const MAIN_TITLE_STYLE = {
  fontFamily: SERIF_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: 24,
  lineHeight: '34px',
  letterSpacing: '0.4px',
}

export const SECONDARY_TITLE_STYLE = {
  fontFamily: SERIF_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: 18,
  lineHeight: '140%',
  letterSpacing: '0.4px',
}

export const NOTES_MEDIUM_STYLE = {
  fontFamily: SANS_SERIF_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '160%',
  letterSpacing: '0.2px',
}

export const NOTES_BOLD_STYLE = {
  fontFamily: SANS_SERIF_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: 14,
  lineHeight: '160%',
  letterSpacing: '0.2px',
}

export const LABELS_STYLE = {
  fontFamily: SANS_SERIF_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: 12,
  lineHeight: '160%',
  letterSpacing: '0.2px',
}

export const BUTTONS_STYLE = {
  fontFamily: SANS_SERIF_FONT_FAMILY,
  fontStyle: 'normal',
  fontWeight: 900,
  fontSize: 14,
  lineHeight: '140%',
  letterSpacing: '1.6px',
}

export const RODEO_E_STYLE = {
  fontStyle: 'italic',
}

export const BODY_MEDIUM_STYLE = {
  fontFamily: SANS_SERIF_FONT_FAMILY,
  fontWeight: 500,
  fontSize: 16,
  lineHeight: '26px',
  letterSpacing: 0.2,
}

export const BODY_BOLD_STYLE = {
  fontFamily: SANS_SERIF_FONT_FAMILY,
  fontWeight: 700,
  fontSize: 16,
  lineHeight: '26px',
  letterSpacing: 0.2,
}
